import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var container = /*#__PURE__*/css(".sorting-tablet-anchor{color:", colors.neutral.heavy.default, ";font-weight:600;top:0;padding:0;line-height:normal;}.domain-icon{color:", colors.neutral.medium.default, ";}li{white-space:nowrap;}");